import React from 'react';
import { Link } from 'react-router-dom';

const newsItems = [
  {
    date: '2025',
    title: 'Sarvanta.ai Launches Cloud-Managed Network as a Service Platform',
    summary: 'Sarvanta officially launches its NaaS platform — delivering AI-powered WiFi optimization, zero-touch provisioning, and multi-tenant cloud management on open hardware. Built by industry veterans from Cisco, Comcast, Ericsson, and Plume, the platform brings enterprise-grade networking to organizations of any size without vendor lock-in.'
  }
];

const News = () => {
  return (
    <div style={{ backgroundColor: '#000503', color: '#fff', minHeight: '100vh', padding: '60px 40px' }}>
      <div style={{ maxWidth: '800px', margin: '0 auto' }}>
        <h1 style={{ fontSize: '2.5rem', marginBottom: '16px' }}>News</h1>
        <p style={{ color: '#a0aec0', fontSize: '1.1rem', marginBottom: '50px', lineHeight: '1.7' }}>
          The latest updates from Sarvanta — product launches, partnerships, and company milestones.
        </p>

        <div style={{ display: 'flex', flexDirection: 'column', gap: '24px' }}>
          {newsItems.map((item, i) => (
            <div key={i} style={{
              padding: '28px', backgroundColor: '#0a1628', borderRadius: '12px',
              border: '1px solid #1a2744'
            }}>
              <span style={{ color: '#2563eb', fontSize: '0.85rem', fontWeight: '600' }}>{item.date}</span>
              <h2 style={{ fontSize: '1.3rem', marginTop: '8px', marginBottom: '12px' }}>{item.title}</h2>
              <p style={{ color: '#a0aec0', lineHeight: '1.7', margin: 0 }}>{item.summary}</p>
            </div>
          ))}
        </div>

        <div style={{ marginTop: '40px', textAlign: 'center' }}>
          <p style={{ color: '#a0aec0', marginBottom: '16px' }}>Want to stay updated?</p>
          <Link to="/contact" style={{
            padding: '12px 28px', border: '2px solid #2563eb', color: '#2563eb',
            borderRadius: '8px', textDecoration: 'none', fontWeight: '600'
          }}>Contact Us for Updates</Link>
        </div>
      </div>
    </div>
  );
};

export default News;
